import React, { useState } from "react";
import "./GenericTooltip.css";
import useIsMobile from "../../hooks/useIsMobile";

const GenericTooltip = ({ 
  tooltipText, 
  tooltipPosition = "bottom", 
  children,
  className = "" 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const isMobile = useIsMobile();

  const showTooltip = () => {
    if (!isMobile) setIsVisible(true);
  };
  const hideTooltip = () => setIsVisible(false);

  return (
    <span 
      className={`generic-tooltip-container ${className}`}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      onFocus={showTooltip}
      onBlur={hideTooltip}
    >
      {children}
      {!isMobile && isVisible && tooltipText && (
        <span className={`generic-tooltip-box position-${tooltipPosition}`}>
          {tooltipText.split('\n').map((line, index) => (
            <span key={index} className="generic-tooltip-line">{line}</span>
          ))}
        </span>
      )}
    </span>
  );
};

export default GenericTooltip;
